module.exports = __webpack_public_path__ + "img/help.af64a941.svg";